var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-24p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6898_182898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6898_182898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home_work",
    d: "M16.6969 9.06785H18.362V7.40272H16.6969V9.06785ZM16.6969 12.8326H18.362V11.1674H16.6969V12.8326ZM16.6969 16.5973H18.362V14.9321H16.6969V16.5973ZM16.1176 20V18.5883H20.353V5.41175H11.5927V7.10046L10.181 6.07968V4H21.7647V20H16.1176ZM2 20V11.2941L8.11764 6.93215L14.2353 11.2941V20H9.18553V15.5294H7.04976V20H2ZM3.41175 18.5883H5.63801V14.1177H10.5973V18.5883H12.8235V12L8.11764 8.67691L3.41175 12V18.5883Z",
    fill: "#A5ACB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWork);
export default __webpack_public_path__ + "static/media/home_work.c5216d24cdd782df12b1086a5f1468e5.svg";
export { ForwardRef as ReactComponent };